import React from "react";

const SortIndicator = ({ sort, sortReverse, colName }) => {
  if (sort !== colName) {
    return null;
  }

  if (sortReverse) {
    return <small className="fa fa-chevron-up" />;
  } else {
    return <small className="fa fa-chevron-down" />;
  }
};

SortIndicator.defaultProps = {
  sort: "",
  sortReverse: false,
  colName: ""
};

export default SortIndicator;



// WEBPACK FOOTER //
// ./src/components/SortIndicator.js